module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ../~/react-modal/lib/index.js
// module id = 669
// module chunks = 0